<div class="div-panel sticky-top auto-archive">
    <div class="header-actions">
        <button
            mat-raised-button
            color="primary"
            (click)="openCreateRuleModal()"
        >
            <mat-icon>add</mat-icon>
            Create Rule
        </button>
    </div>
</div>

<table
    mat-table
    [dataSource]="dataSource"
    class="mat-elevation-z8 auto-archive"
    multiTemplateDataRows
>
    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
    </ng-container>

    <ng-container matColumnDef="endpoint">
        <th mat-header-cell *matHeaderCellDef>Endpoint</th>
        <td mat-cell *matCellDef="let row">{{ row.endpoint }}</td>
    </ng-container>

    <ng-container matColumnDef="method">
        <th mat-header-cell *matHeaderCellDef>Method</th>
        <td mat-cell *matCellDef="let row">{{ row.method }}</td>
    </ng-container>

    <ng-container matColumnDef="sendingSystem">
        <th mat-header-cell *matHeaderCellDef>Sending System</th>
        <td mat-cell *matCellDef="let row">{{ row.sendingSystem }}</td>
    </ng-container>

    <ng-container matColumnDef="sendingUnit">
        <th mat-header-cell *matHeaderCellDef>Sending Unit</th>
        <td mat-cell *matCellDef="let row">{{ row.sendingUnit }}</td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Created At</th>
        <td mat-cell *matCellDef="let row">
            {{ row.createdAt | date : "short" }}
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let rule">
            <button
                mat-icon-button
                color="primary"
                (click)="onEdit(rule); $event.stopPropagation()"
                aria-label="edit"
            >
                <mat-icon>edit</mat-icon>
            </button>
            <button
                mat-icon-button
                color="warn"
                (click)="onDelete(rule); $event.stopPropagation()"
                aria-label="delete"
            >
                <mat-icon>delete</mat-icon>
            </button>
        </td>
    </ng-container>

    <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">
            &nbsp;
        </th>
        <td mat-cell *matCellDef="let rule">
            <button
                mat-icon-button
                aria-label="expand row"
                (click)="toggle(rule); $event.stopPropagation()"
                class="toggle-button"
                [class.toggle-button-expanded]="isExpanded(rule)"
            >
                <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
        </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
        <td
            mat-cell
            *matCellDef="let rule"
            [attr.colspan]="displayedColumns.length"
        >
            <div
                class="conditions-detail-wrapper"
                [class.conditions-detail-wrapper-expanded]="isExpanded(rule)"
            >
                <div class="conditions-detail">
                    <table>
                        <tr>
                            <th>Property</th>
                            <th>Discovery Code</th>
                            <th>Pattern Type</th>
                            <th>Value</th>
                            <th>Created At</th>
                        </tr>
                        <tr *ngFor="let condition of rule.conditions">
                            <td>{{ condition.property }}</td>
                            <td>{{ condition.errorCode }}</td>
                            <td>
                                {{
                                    getPatternTypeLabel(
                                        condition.displayRegexPatternType
                                    )
                                }}
                            </td>
                            <td>{{ condition.displayRegexValue }}</td>
                            <td>
                                {{ condition.createdAt | date : "short" }}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.expanded-row]="isExpanded(row)"
    ></tr>

    <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="detail-row"
    ></tr>

    <tr mat-row *matRowDef="let row; columns: []" class="detail-row"></tr>
</table>
